import { render, staticRenderFns } from "./PortalMessageButton.vue?vue&type=template&id=2e03892e"
import script from "./PortalMessageButton.vue?vue&type=script&lang=js"
export * from "./PortalMessageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports